import { LoadingOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import { FC, useEffect } from "react";
import { BsChatDots } from "react-icons/bs";

import { useChat } from "@app/features/chat/ChatProvider";
import { useSdk } from "@app/shared/lib/hooks";

import { Header } from "../Header";

export const Chat: FC = () => {
  const chat = useChat();
  const sdk = useSdk();

  useEffect(() => {
    const dispose = sdk.hub.school.supportChatEnabled.subscribe((enabled) => {
      // The switch belongs to the old support chat; the membership chat is governed by its channel.
      if (!enabled && chat.kind === "legacy") {
        chat.chatController?.close();
      }
    });

    return () => dispose();
  }, [chat.chatController, chat.kind, sdk.hub.school.supportChatEnabled]);

  return (
    <Header.Item
      onClick={() => {
        if (chat.chatController?.visible) {
          chat.chatController.close();
        } else {
          chat.chatController?.open();
        }
      }}
    >
      {chat.chatController && (
        <Badge
          count={chat.unreadCount}
        >
          <Button
            icon={chat.isChatInited ? <BsChatDots /> : <LoadingOutlined />}
            type="link"
            shape="circle"
            className="bg-gray-3 secondary-text"
          />
        </Badge>
      )}
    </Header.Item>
  );
};
